import React from 'react';
import { ArrowRight, Utensils, HandHeart, Brain } from 'lucide-react';
import { CAUSES } from '../data/mock';

const iconMap = {
  1: Utensils,
  2: HandHeart,
  3: Brain,
};

const HowWeHelp = () => {
  return (
    <section id="causes" className="py-24 bg-gradient-to-b from-[#FFF7F1] to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-block px-4 py-1.5 bg-[#0B3B44]/5 text-[#0B3B44] font-semibold text-xs uppercase tracking-widest rounded-full mb-4">
            How We Help
          </div>
          <h2 className="text-4xl lg:text-5xl font-extrabold text-[#0B3B44] leading-tight mb-4">
            Paving the way to a <span className="text-[#F55B26]">better tomorrow.</span>
          </h2>
          <p className="text-lg text-slate-600">
            Almost 1 in 2 South Africans live below the poverty line — nearly 10 million
            kids go hungry each day. Our battle is against indifference.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {CAUSES.map((cause) => {
            const Icon = iconMap[cause.id] || HandHeart;
            return (
              <article
                key={cause.id}
                className="group relative bg-white rounded-3xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 border border-slate-100"
              >
                <div className="relative h-56 overflow-hidden">
                  <img
                    src={cause.image}
                    alt={cause.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0B3B44]/70 via-[#0B3B44]/20 to-transparent" />
                  <div className="absolute top-4 left-4 px-3 py-1 bg-white/95 backdrop-blur rounded-full text-xs font-bold text-[#F55B26]">
                    {cause.stats}
                  </div>
                  <div className="absolute bottom-4 left-4 w-12 h-12 rounded-2xl bg-white shadow-lg flex items-center justify-center">
                    <Icon className="w-6 h-6 text-[#F55B26]" />
                  </div>
                </div>
                <div className="p-6 space-y-3">
                  <div>
                    <h3 className="text-2xl font-extrabold text-[#0B3B44]">{cause.title}</h3>
                    <p className="text-sm text-[#F55B26] font-semibold">{cause.tagline}</p>
                  </div>
                  <p className="text-slate-600 leading-relaxed text-sm">{cause.description}</p>
                  <a
                    href={cause.id === 3 ? '#hello-support' : `mailto:${cause.email}`}
                    onClick={(e) => {
                      if (cause.id === 3) {
                        e.preventDefault();
                        document.querySelector('#hello-support')?.scrollIntoView({ behavior: 'smooth' });
                      }
                    }}
                    className="inline-flex items-center gap-2 pt-2 text-[#F55B26] font-semibold hover:gap-3 transition-all"
                  >
                    {cause.cta}
                    <ArrowRight className="w-4 h-4" />
                  </a>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowWeHelp;
